import { LiveSiteChannel_Read } from '@treadinc/horizon-api-spec';

import connection from '~services/connectionModule';
import { realTimeChannels } from '~services/realTimeChannels';

import { LiveSiteData } from './models';

interface SubscribeToLiveSiteUpdatesProps {
  onMessageCallBack: (data: LiveSiteData) => void;
  companyId: string;
}

const isValidSiteData = (data: LiveSiteChannel_Read | undefined) => {
  return Boolean(data?.site?.lat && data?.site?.lon);
};

export const useLiveSiteLocations = () => {
  const subscribeToLiveSiteUpdates = ({
    onMessageCallBack,
    companyId,
  }: SubscribeToLiveSiteUpdatesProps) => {
    const consumer = connection.realTimeConnection;
    const channel = realTimeChannels.LiveSiteChannel;

    let subscription = consumer?.subscriptions.subscriptions.find((sub) => {
      return sub.identifier.includes(channel);
    });

    if (!subscription) {
      subscription = consumer?.subscriptions?.create?.(
        {
          channel: channel,
          company_id: companyId,
        },
        {
          // oxlint-disable-next-line @typescript-eslint/no-empty-function
          connected: () => () => {},
          // oxlint-disable-next-line @typescript-eslint/no-empty-function
          disconnected: () => () => {},
          received: ({ data }: { data: LiveSiteChannel_Read }) => {
            if (isValidSiteData(data)) {
              const locationData = LiveSiteData.parse(data);
              onMessageCallBack(locationData);
            }
          },
        },
      );
    }

    return subscription;
  };

  return { subscribeToLiveSiteUpdates };
};
